import { parse } from 'qs'

const parseQuery = (location) => {
  return parse(location.search.replace(/^\?/, ''))
}

export { parseQuery }
